export default "__VITE_ASSET__c94bb51b__"